import React, { useState, useEffect } from "react";
import { Container, Box, Typography, TextField, Button } from "@mui/material";
import Loader from "../../components/Loader";
import { withTranslation } from "react-i18next";
import { InsertUpdateCountryAdminUrl, GetCountryAdminDetailUrl } from "../../utils/constants";
import { axiosGet, axiosPost } from "../../utils/Axios";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../components/toast';
import { HeaderBlock } from "@colliers/colliers-b2c";

const CountryManage = () => {

    const { ToastComponent, showToast } = useToast();

    const { t } = useTranslation();

    const location = useLocation();
    const [editCountryID] = useState(() => location.state?.editCountryID ?? null);

    const [isLoading, setIsLoading] = useState(false);
    const [validate, setValidate] = useState(false);

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/country');
        console.log("Canceled!");
    };

    useEffect(() => {
        console.log(location.state, 'country state......')
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate('/login/KeyStone_Login');
            return;
        } else {
            getCountryInfo();
        }
    }, []);

    const [countryName, setCountryName] = useState("");



    const getCountryInfo = async () => {
        setIsLoading(true);
        try {
            const data = await axiosGet(`${GetCountryAdminDetailUrl}?editCountryID=${editCountryID}`);
            if (data != null) {
                setCountryName(data.countryName);

            }
            else {
                console.error("Failed to fetch group data: No data found.");
            }
        }
        catch (error) {
            console.error("Error fetching group data:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleGroupNameChange = (event) => {
        setCountryName(event.target.value);
    };


    const handleSave = async () => {
        setValidate(true);

        if (!countryName) {
            console.error("Mandatory fields are required");
            return;
        }



        try {
            setIsLoading(true);
            const response = await axiosPost(`${InsertUpdateCountryAdminUrl}?editCountryID=${editCountryID ? editCountryID : 0}&CountryName=${countryName.trim()}`);
            if (response.code !== 200) {
                showToast('error', response.responseMsg ? response.responseMsg : 'Failed to save Country!');
                console.error("Failed to process Country: No data found.");
                return;
            }

            setValidate(false);
            showToast('success', `Successfully ${editCountryID > 0 ? 'Updated' : 'Saved'}!`);
            setTimeout(() => navigate('/country'), 1000);

        } catch (error) {
            showToast('error', `Failed to ${editCountryID > 0 ? 'update' : 'save'} Country!`);
            console.error(`Error processing Country Admin:`, error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={t('dashboardGroup.country')} leftCenterAlign="true" actionsCenterAlign="true" />

            <Box id="main" className="countryMain">

                <Container>
                    <Box className="margin-bottom-m border-light border-radius-soft padding-xs padding-y-base padding-x-base"
                        sx={{
                            maxWidth: 800,
                            margin: "2rem auto",
                        }}
                    >
                        <Typography className="font-size-h5 text-primary-dark margin-bottom-base text-uppercase"
                            variant="h6"
                        >
                            {t('dashboardGroup.country')}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <TextField className="padding-top-base margin-top-s  margin-bottom-s"
                                fullWidth
                                label={t('dashboardGroup.country')}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 100,  // Set the maxLength to 100 characters
                                }}
                                placeholder={t('dashboardGroup.CountryAdminPlaceholder')}
                                variant="outlined" value={countryName} onChange={handleGroupNameChange}
                                error={validate && (countryName == "" || countryName == null)}
                                helperText={validate && !countryName ? t('dashboardGroup.pleaseEnterCountry') : ""}
                            />

                        </Box>

                        <Box className="" display="flex" justifyContent="center" mt={2} gap={2}>
                            <Button className="margin-right-base"
                                variant="contained"
                                color="primary"
                                onClick={handleSave}
                            >
                                {t('dashboardGroup.save')}
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleCancel}
                            >
                                {t('dashboardGroup.cancel')}
                            </Button>
                        </Box>
                    </Box>
                </Container>
                {ToastComponent}
            </Box>
        </>
    );
};

export default withTranslation()(CountryManage);
